import {omit} from 'lodash';
import React from 'react';

import {WBAgentRunFilterContextSlice} from '../../../aria/externalBindings/WBAgentContextSlices';
import {WBAgentSetFilterActionSlice} from '../../../aria/externalBindings/WBAgentSetFilterActionSlice';
import {type Ref} from '../../../state/views/filter/types';
import {usePart} from '../../../state/views/hooks';
import {WBTableActionFilterButton} from '../WBTable/WBTableActionsFilter';

interface RunsFilterButtonProps {
  compact?: boolean;
  notificationOpen: boolean;
  filtersOpen: boolean;
  filtersRef: Ref;
  extraFilterCount?: number;
}

export const RunsFilterButton = (props: RunsFilterButtonProps) => {
  const filters = usePart(props.filtersRef);
  const passThroughProps = omit(
    props,
    'compact',
    'filtersOpen',
    'filtersRef',
    'extraFilterCount'
  );

  return (
    <>
      <WBAgentRunFilterContextSlice filters={filters} />
      <WBAgentSetFilterActionSlice filtersRef={props.filtersRef} />
      <WBTableActionFilterButton
        {...passThroughProps} // Required for use as popup trigger
        compact={props.compact}
        filtersOpen={props.filtersOpen}
        filters={filters}
        extraFilterCount={props.extraFilterCount}
      />
    </>
  );
};
